import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

interface PropTypes {
  color?: string;
  size?: number;
}

function Loading({ color, size = 80 }: PropTypes) {
  return (
    <div>
      <ClipLoader color={color || '#ffffff'} size={size} />
    </div>
  );
}

export default Loading;
